import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import { FormAccordionSection } from 'components';
import { updateMessage, orgInitialState } from 'redux/modules/groupPostCompose';
import twitterText from 'twitter-text';
var GMessageArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    groupPost: state.groupPostCompose,
    organization: state.organization.current,
    organizationId: state.organization.current.id
  };
}, {
  updateMessage: updateMessage
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GMessageArea, _Component);

  var _super = _createSuper(GMessageArea);

  function GMessageArea() {
    var _this;

    _classCallCheck(this, GMessageArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e, value) {
      var organizationId = _this.props.organizationId;

      _this.props.updateMessage(e.target.id, value, organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateTweetLength", function (inStr) {
      var text = " ".concat(inStr || '').slice(1); // make copy of string

      var attachedLink = _this.props.groupPost.linkData && _this.props.groupPost.linkData.link ? _this.props.groupPost.linkData.link : null;

      if (attachedLink) {
        text += " ".concat(attachedLink);
      }

      return twitterText.getTweetLength(text);
    });

    return _this;
  }

  _createClass(GMessageArea, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var groupPost = this.props.groupPost;
      var advancedMessageArea = /*#__PURE__*/React.createElement(FormAccordionSection, {
        toggleLabel: "Advanced",
        open: !!groupPost.messages.facebook || !!groupPost.messages.twitter
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0 10px'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "facebook",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: '100%'
        },
        value: groupPost.messages.facebook,
        floatingLabelText: "Custom Facebook Message",
        floatingLabelFixed: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "twitter",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: '100%'
        },
        value: groupPost.messages.twitter,
        floatingLabelText: "Custom X (Twitter) Message",
        floatingLabelFixed: true
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          width: '100%',
          textAlign: 'right',
          color: 280 - this.calculateTweetLength(groupPost.messages.twitter) < 0 ? 'red' : '#8b8b8b'
        }
      }, 280 - this.calculateTweetLength(groupPost.messages.twitter), " Characters Remaining"))), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "linkedin",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: '100%'
        },
        value: groupPost.messages.linkedin,
        floatingLabelText: "Custom LinkedIn Message",
        floatingLabelFixed: true
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          width: '100%',
          textAlign: 'right',
          color: 2000 - (groupPost.messages.linkedin ? groupPost.messages.linkedin.length : 0) < 0 ? 'red' : '#8b8b8b'
        }
      }, 2000 - (groupPost.messages.linkedin ? groupPost.messages.linkedin.length : 0), " Characters Remaining")))));
      var temp = '';
      var showAdvancedMessage = groupPost.selectedAccounts.facebookProfile || groupPost.selectedAccounts.facebookPage || groupPost.selectedAccounts.linkedinCompany || groupPost.selectedAccounts.linkedinProfile || groupPost.selectedAccounts.twitter;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "global",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: '100%'
        },
        value: groupPost.messages.global
      }), advancedMessageArea);
    }
  }]);

  return GMessageArea;
}(Component)) || _class);
export { GMessageArea as default };